export default __webpack_public_path__ + "static/media/fullscreen-white-ico.f04eb454.svg";